// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/companies/:company_id/developers/table" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { companiesCompanyIdDevelopersTable } from "./constants";
import type { CompaniesCompanyIdDevelopersTableParams, DevelopersTableResult } from "./types";

export const getDevelopersTable = reactQueryTableFetcherAdapter(
  companiesCompanyIdDevelopersTable,
  (
    signal: AbortSignal,
    {
      companyId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      excludeImpersonationAccounts = true,
      reducedData,
    }: CompaniesCompanyIdDevelopersTableParams
  ): Promise<DevelopersTableResult> => {
    return fetch(
      `/companies/${companyId}/developers/table`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        exclude_impersonation_accounts: excludeImpersonationAccounts,
        reduced_data: reducedData,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
